import { msalInstance } from './authConfig'

export function initalizeAzureADAsync(): Promise<void> {
  return msalInstance.initialize().then(() => console.info('MSAL initialisé'))
}
